import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgOperationSystem = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-operation-system';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M8.34 4.24 7.1 6.237l-1.93.001-1.93.002v11.48h8v2.52H7v1.52h10v-1.52h-4.24v-2.52h8V6.241l-1.967-.011-1.967-.01-1.203-1.99-1.203-1.989-2.42.001-2.42.001zm6.201 1.106c.527.873.959 1.617.959 1.654s-.432.781-.959 1.654l-.96 1.586H10.41l-.994-1.59C8.87 7.776 8.423 7.033 8.423 7s.447-.776.993-1.65l.994-1.59h3.171zm-3.09.246c-.577.231-.93.783-.882 1.379.03.366.16.632.434.886.576.533 1.377.498 1.923-.086.64-.684.368-1.84-.509-2.169-.275-.103-.723-.107-.966-.01m.542 1.163c.03.019.048.077.04.13-.01.071-.038.095-.113.095s-.103-.024-.113-.095c-.012-.082.045-.164.113-.164.011 0 .044.015.073.034M8.34 9.76l1.24 1.997 2.42.001 2.42.001 1.203-1.989 1.203-1.99 1.207-.011 1.207-.01V16.2H4.76V7.76l1.17.002 1.17.001z"
    })
  }));
});
export default SvgOperationSystem;